const state = {
  curriculums: [],
  originalStateCurriculums: [],
  loading: false,
  listCurriculums: [],
};

const getters = {};

const actions = {
  getCourses() {
    return this._vm.axios.get(
      // eslint-disable-next-line
      '/client/lms/course-certifications'
    );
  },
  getCurriculums() {

  },
  editCourse({ commit }, payload) {
    commit('editCourse', payload);
  },
  deleteCourse({ commit }, payload) {
    commit('deleteCourse', payload);
  },
  addCourse({ commit }, payload) {
    commit('addCourse', payload);
  },
  setCourses({ commit }, payload) {
    commit('setCourses', payload);
  },
  setLoading({ commit }, payload) {
    commit('setLoading', payload);
  },
};

const mutations = {
  setListCurriculums: (st, data) => {
    st.listCurriculums = data;
  },
  setCourses: (st, data) => {
    // eslint-disable-next-line no-param-reassign
    st.curriculums = data;
    st.originalStateCurriculums = JSON.stringify(data);
  },
  addCourse: (st, { userIndex, item }) => {
    st.curriculums[userIndex].courses.unshift(item);
    st.originalStateCurriculums = JSON.stringify(st.curriculums);
  },
  editCourse: (st, { index, result }) => {
    st.curriculums.splice(index, 1, result);
  },
  deleteCourse: (st, { index, courseIndex }) => {
    st.curriculums[index].courses.splice(courseIndex, 1);
    st.originalStateCurriculums = JSON.stringify(st.curriculums);
  },
  setLoading: (st, data) => {
    st.loading = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
